var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5764_17072)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.6104,
    cy: 19.7198,
    r: 4.22762,
    fill: "#FB7401",
    stroke: "#FB7401",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6104,
    cy: 6.57137,
    r: 4.22762,
    stroke: "#91BDFA",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.74325,
    cy: 19.7198,
    r: 4.22762,
    stroke: "#91BDFA",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.74325,
    cy: 6.57137,
    r: 4.22762,
    stroke: "#91BDFA",
    strokeWidth: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5764_17072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.835938 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard1);
export default __webpack_public_path__ + "static/media/Dashboard1.c3cb82207a97deddebb0b632a27ce0c8.svg";
export { ForwardRef as ReactComponent };